export default __webpack_public_path__ + "static/media/LeftHandPitcher.f327500c.png";